import {
  SAVE_TIMESERIES_RESPONSE,
  FETCH_TIMESERIES_REQUEST,
  FETCH_TIMESERIES_RESPONSE,
  LIST_UNIT_TIMESERIES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// timeseriesId -> {timeseries metadata}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case FETCH_TIMESERIES_REQUEST:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
        },
      }

    case FETCH_TIMESERIES_RESPONSE:
    case SAVE_TIMESERIES_RESPONSE:
      return {
        ...state,
        [action.timeseries.id]: action.timeseries,
      }

    case LIST_UNIT_TIMESERIES_RESPONSE: {
      const s = { ...state }
      const timeseries = action.timeseries || []
      timeseries.forEach((ts) => {
        s[ts.id] = { ...ts }
      })
      return s
    }

    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
